import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ContractStatus } from 'src/app/shared/interfaces/contract.status.enum';
import { ContractingService } from 'src/app/shared/services/contracting.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterModule,
        CommonModule
    ],
    selector: 'app-loading-contract-layout',
    templateUrl: './loading-contract-layout.component.html'
})
export class LoadingContractLayoutComponent {

  constructor() {
    this.ar.paramMap.subscribe(params => {
      const uid = params.get('id');
      this.contractingService.checkContracting(uid!).subscribe();
    });
  }

  private contractingService = inject(ContractingService);
  private router = inject(Router);
  private ar = inject(ActivatedRoute);

  public finishedCheckOperation = computed<boolean>(() => {

    if (this.contractingService.contractStatus() === ContractStatus.checking) {
      return false;
    }

    return true;
    
  });

  public authStatusChangedEffect = effect(() => {
    switch( this.contractingService.contractStatus() ) {

      case ContractStatus.checking:
        return;

      case ContractStatus.exists:
        if ( this.contractingService.currentOperation()?.contract?.signature) {
          this.router.navigateByUrl('contracting/' + this.contractingService.currentOperation()?.uid + '/completed');
          return;
        }
        if (!this.contractingService.currentOperation()) {
          this.router.navigateByUrl('contracting/' + this.contractingService.currentOperation()?.uid + '/error');
          return;
          
        }
        // Dev purposes only
        // this.router.navigateByUrl('contracting/' + this.contractingService.currentOperation()?.uid + '/sign');
        // Uncomment this line: 
        this.router.navigateByUrl('contracting/' + this.contractingService.currentOperation()?.uid + '/acceder');
        return;
        
      case ContractStatus.notExists:
        this.router.navigateByUrl('contracting/' + 'undefined' + '/error');
        return;

    }

  });

}
